<template>
    <el-container class="statistic" v-wechat-title="$route.meta.title">
        <div class="loading-content" v-if="statisticLoading">
            <div class="loading-box">
                <span><i class="el-icon-loading"></i></span>
            </div>
        </div>
        <el-main v-else>
            <div class="statistic-title column-header">
                <span>订单统计</span>
                <span @click="shrinkEvent"><i class="fa fa-chevron-down" aria-hidden="true"></i></span>
            </div>
            <div class="statistic-content">
                <div class="statistic-content-total" v-if="currencyFlag">
                    <div class="total-item" v-if="isHandleList">
                        <div class="total-item-title">
                            <h3>汇总</h3>
                            <div>
                                <span @click="getTotalData('1')" :style="{'color': timeActive('1')}">1h</span>
                                <span @click="getTotalData('24')" :style="{'color': timeActive('24')}">24h</span>
                                <span @click="getTotalData('48')" :style="{'color': timeActive('48')}">48h</span>
                            </div>
                        </div>
                        <div class="total-item-value">
                            <span>+</span>
                            <span>{{handleTotalData['automatic']['pool']}} / {{handleTotalData['automatic']['pool_accounted']}}%</span>
                            <span>-</span>
                        </div>
                        <table>
                            <thead>
                                <tr>
                                    <th class="border-right"></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="border-right">{{handleTotalData['automatic']['more']}}</td>
                                    <td>{{handleTotalData['automatic']['empty']}}</td>
                                </tr>
                                <tr>
                                    <td class="border-right">{{handleTotalData['automatic']['fu_more']}}</td>
                                    <td>{{handleTotalData['automatic']['fu_empty']}}</td>
                                </tr>
                                <tr>
                                    <td class="border-right">{{handleTotalData['automatic']['ss_buy']}}</td>
                                    <td>{{handleTotalData['automatic']['ss_sell']}}</td>
                                </tr>

                                <tr class="manual">
                                    <td colspan="2" style="text-align: center; font-size: 13px;">{{handleTotalData['manual']['pool']}} / {{handleTotalData['manual']['pool_accounted']}}%</td>
                                </tr>
                                <tr class="manual">
                                    <td class="border-right">{{handleTotalData['manual']['more']}}</td>
                                    <td>{{handleTotalData['manual']['empty']}}</td>
                                </tr>
                                <tr class="manual">
                                    <td class="border-right">{{handleTotalData['manual']['fu_more']}}</td>
                                    <td>{{handleTotalData['manual']['fu_empty']}}</td>
                                    
                                </tr>
                                <tr class="manual">
                                    <td class="border-right">{{handleTotalData['manual']['ss_buy']}}</td>
                                    <td>{{handleTotalData['manual']['ss_sell']}}</td>
                                </tr>
                                
                            </tbody>
                        </table>
                    </div>
                    <div class="total-item" v-for="(data, index_t) in orderStat" :key="'t-'+index_t">
                        <div class="total-item-title">
                            <h3>{{data['currency'].toUpperCase()}}</h3>
                            <div>
                                <span @click="showTimeSelect('h', data['currency'])" :style="{'color': timeActive('h', data['currency'])}">1h</span>
                                <span @click="showTimeSelect('d', data['currency'])" :style="{'color': timeActive('d', data['currency'])}">24h</span>
                                <span @click="showTimeSelect('m', data['currency'])" :style="{'color': timeActive('m', data['currency'])}">48h</span>
                            </div>
                        </div>
                        <div class="total-item-value">
                            <span>+</span>
                            <span>{{data['pool']}} / {{data['pool_accounted']}}%</span>
                            <span>-</span>
                        </div>
                        <table>
                            <thead>
                                <tr>
                                    <th class="border-right"></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="border-right">{{valueJudge(data['more'])}}</td>
                                    <td>{{valueJudge(data['empty'])}}</td>
                                </tr>
                                <tr>
                                    <td class="border-right">{{valueJudge(data['fu_more'])}}</td>
                                    <td>{{valueJudge(data['fu_empty'])}}</td>
                                </tr>
                                <tr>
                                    <td class="border-right">{{valueJudge(data['ss_buy'])}}</td>
                                    <td>{{valueJudge(data['ss_sell'])}}</td>       
                                </tr>
                                <tr class="manual">
                                    <td colspan="2" style="text-align: center; font-size: 13px;">{{statSocketData['manual'][index_t]['pool']}} / {{statSocketData['manual'][index_t]['pool_accounted']}}%</td>
                                </tr>
                                <tr class="manual">
                                    <td class="border-right">{{valueJudge(statSocketData['manual'][index_t]['more'])}}</td>
                                    <td>{{valueJudge(statSocketData['manual'][index_t]['empty'])}}</td>
                                </tr>
                                <tr class="manual">
                                    <td class="border-right">{{valueJudge(statSocketData['manual'][index_t]['fu_more'])}}</td>
                                    <td>{{valueJudge(statSocketData['manual'][index_t]['fu_empty'])}}</td>
                                </tr>
                                <tr class="manual">
                                    <td class="border-right">{{valueJudge(statSocketData['manual'][index_t]['ss_buy'])}}</td>
                                    <td>{{valueJudge(statSocketData['manual'][index_t]['ss_sell'])}}</td>                                    
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <StatisticQuery></StatisticQuery>
                <div class="total-detail">
                    <div class="total-detail-header">
                        <div>
                            <!-- <input type="text"> -->
                        </div>
                    </div>
                    <table class="total-detail-table">
                        <thead>
                            <tr>
                                <th v-for="(item1, index1) in statisticTableName" :key="'1-'+index1">{{item1}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(data, index_d) in realData" :key="index_d">
                                <!-- <td>{{data['order_id']}}</td> -->
                                <td>
                                    <el-tooltip :content="String(data['client_id'])" placement="top">
                                        <el-button>{{clientIdCut(data['client_id'])}}</el-button>
                                    </el-tooltip>
                                </td>
                                <td>{{data['api_name']}}</td>
                                <td>{{data['bourse']}}</td>
                                <td>{{taskIdJudge(data['task_id'])}}</td>
                                <td style="min-width: 90px">{{data['instrument_id']}}</td>
                                <td>{{data['price']}}</td>
                                <td>{{data['amount']}}</td>
                                <td>{{data['type']}}</td>
                                <td>{{data['filled_amount']}}</td>
                                <td>{{data['filled_price']}}</td>
                                <td>{{Number(data['filled_notional']).toFixed(4)}}</td>
                                <td :style="{'color': typesJudge(data['types'])}">{{data['types']}}</td>
                                <td>{{data['fee']}}</td>
                                <td>{{data['timestamp']}}</td>
                                <td>{{data['trading_time']}}</td>
                                <td>{{data['state']}}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="total-footer" v-if="turnShow">
                        <span class="left-page" @click="toPage('go')"><i class="fa fa-chevron-left" aria-hidden="true"></i></span>
                        <span>{{pages}}</span>
                        <span class="right-page" @click="toPage('back')"><i class="fa fa-chevron-right" aria-hidden="true"></i></span>
                        <span>共 {{totalPages}} 页</span>
                        <input type="text" class="jump-turn-page" v-model="pageNum"> 
                        <button class="jump-page-btn" @click="jumpPage"> <i class="fa fa-angle-double-right" aria-hidden="true"></i> </button>
                    </div>
                    <div class="total-footer" v-else><i class="fa fa-spinner" aria-hidden="true"></i></div>
                </div>
            </div>
        </el-main>
    </el-container>
</template>

<script>
/* eslint-disable */
import Header from '@/components/header/Header.vue'
import Footer from '@/components/Footer/New-footer.vue'
import { get } from '@/api/index'
import { mapState, mapActions } from 'vuex'
import { type } from 'os'
import StatisticQuery from '@/views/statistic/Statistic-query.vue'
import { setInterval, clearInterval } from 'timers';
import { Promise } from 'q';

export default {
    components: {
        Header,
        Footer,
        StatisticQuery
    },
    data() {
        return {
            statisticData: {}, 
            statisticData1: [],
            tagList: ['API', '币种', '日期', '任务'],
            currencyList: ['btc', 'eth', 'bch', 'eos', 'etc',  'xrp', 'ltc', 'trx', 'bsv'],
            paramData: {},
            totalStatisticData: {},
            currencyTotalData: {},

            statisticTotalData: [],
            statisticTableName: ['流水号', 'API', '交易所', '任务', '币种', '委托价格', '委托数量', '类型', '成交数量', '成交价格','成交金额', '交易类型', '手续费', '时间','时间差', '状态'],
            statTotalParam: [],
            statTimer1: null,
            statSocketData: {},
            statSocketList: [],
            currency_obj: {}, 
            pageFlag: true,
            pages: 1,
            orderNum: 18,
            currencyFlag: true,
            totalSelect: '48',
            pageNum: '',
            turnShow: true,
            statisticLoading: false,
            totalPages: '',

            orderCurrencyData: [],
            orderDetail: [],
        }
    },
    mounted() {
        var param = {
            'number': this.orderNum
        };
        for (var i=0; i<this.currencyList.length; i++) {
            this.currency_obj[this.currencyList[i]] = 2880;
        }
        this.initStatisticSocket();
        this.getStatisticTotalData(param).then((data) => {
        });
        if (this.apiNameList.length == 0) {
            // 如果api 列表为空，则重新获取列表
            this.getApiList().then(data => {
                this.getTotalData(this.totalSelect);
            });
        } else {
            this.getTotalData(this.totalSelect);
        }
        if (this.taskList.length == 0) {
            // 如果任务列表为空，则重新获取
            this.getTaskList();
        }

        this.getPageStatData(1);
    },
    computed: {
        ...mapState([
            'apiNameList',
            'taskList',
            'statWebsocket',
            'statTimer',
        ]),
        // 计算总的统计值
        totalData: function() {
            var finallData = {'fu_empty': 0, 'fu_more': 0, 'ss_buy': 0, 'ss_sell': 0};
            // 将每个API的下的值都加起来
            for (var i in this.totalStatisticData) {
                var data = this.totalStatisticData[i];
                for (var j in data) {
                    if (data[j] !== null) {
                        finallData[j] += data[j];
                    }
                }
            }
            return finallData;
        },

        // 将socket
        realData: function() {
            if (this.pages == 1) {
                return this.statSocketData.order;
            } else {
                return this.statisticTotalData;
            }
        },

        // 处理按条件 筛选的数据
        judgeData: function() {
            var finallData = {};
            if (this.statisticData == null) return;
        },

        // 总统计值处理
        handleTotalData: function () {
            var finall_data = {};
            if (this.statisticData) {
                for (var j in this.statisticData) {
                    var paramObj = {};
                    for (var i in this.statisticData[j]) {
                        paramObj[i] = this.statisticData[j][i].toFixed(2)
                    }
                    finall_data[j] = paramObj;
                }
                return finall_data;
            }
        },

        //订单统计
        orderStat: function () {
            if (JSON.stringify(this.statSocketData) !== '{}') {
                return this.statSocketData['automatic'];
            }
        },

        isHandleList: function () {
            console.log('ishandle', typeof this.handleTotalData['automatic'] !== 'undefined' && typeof this.handleTotalData['manual'] !== 'undefined')
            return typeof this.handleTotalData['automatic'] !== 'undefined' && typeof this.handleTotalData['manual'] !== 'undefined';
        }
    },
    methods: {
        ...mapActions([
            'getApiList',
            'getTaskList',
            'createStatisticSocket',
        ]),

        // 获取订单统计数据
        getOrderData(param) {
            var url = 'http://107.149.104.7:9999/web/query/order/SDC';
            get(url, param).then(resp => {
                if (resp.code == 200) {
                    // this.statisticData = resp.data;
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        },

        // 统计数值处理
        valueJudge(data) {
            if (data == null) return 'NULL';
            return Number(data).toFixed(2);
        },

        // 字段名称转译
        keyJudge(name) {
            if (name == 'fu_more') return '多';
            else if (name == 'fu_empty') return '空';
            else if (name == 'ss_sell') return '卖';
            else if (name == 'ss_buy') return '买';
        },

        // 获取所有统计数据
        getAllStatistic() {
            var apiIdArray = [0];
            if (this.apiNameList.length > 0) {
                for (var i in this.apiNameList) {
                    apiIdArray.push(this.apiNameList[i].id);
                }
            }
            var param = {
                'apis': JSON.stringify(apiIdArray),
            }
            this.getOrderData(param);
        },

        // 初始化 websocket
        initStatisticSocket(){
            if (this.statWebsocket && this.statWebsocket['socket']) {
                this.socketSendMsg()
            } else {// websocket 连接断开，创建 socket 连接 
                this.createStatisticSocket().then(() => {
                    // 调用发送 消息函数
                    this.socketSendMsg()
                });
            }
        },

        // socket 发送请求函数
        socketSendMsg() {
            // 默认参数设置
            var param = this.socketParam();

            // 第一次请求
            this.statWebsocket.sendMsg(JSON.stringify(param)).then(resp => {
                if (resp.code == 200) {
                    this.statSocketData = resp.data;
                    this.statisticLoading = false;
                } 
            }).catch(error => {
                console.warn(error)
            })
            
            this.statTimer['timer'] = setInterval(() => {
                var param = this.socketParam();
                this.statWebsocket.sendMsg(JSON.stringify(param)).then(resp => {
                    if (resp.code == 200) {
                        this.statisticLoading = false;
                        this.statSocketData = resp.data;
                    } 
                }).catch(error => {
                    console.warn(error)
                    // 发生异常清除定时器
                    clearInterval(this.statTimer['timer']);
                })
            }, 2000)

            // 组件销毁时，清除定时器
            this.$once('hook:beforeDestroy', () => {
                clearInterval(this.statTimer['timer']);
            })
        },

        /* socket 新 */
        socketEvent() {
            this.statisticSocket['socket'].onopen = this.socketOpen;
            this.statisticSocket['socket'].onmessage = this.socketMessage;
            this.statisticSocket['socket'].onerror = this.socketError;
            this.statisticSocket['socket'].onClose = this.socketClose;
        },
        
        // websocket 接收函数
        socketMessage(resp) {
            // console.log(resp);
            let real_resp = JSON.parse(resp.data);
            if (real_resp.code == 200) {
                if (real_resp.hasOwnProperty('data')) {
                    // console.log(new Date().getSeconds(), real_resp);
                    this.statSocketData = real_resp.data;
                    this.orderCurrencyData = real_resp.data['automatic'];
                    console.log(this.orderCurrencyData);
                    this.statisticLoading = false;
                }
            }
        },

        // websocket 发送函数
        socketOpen() {
            let param = this.socketParam();
            this.statisticSocket['socket'].send(JSON.stringify(param));
            this.statisticSocket['timer'] = setInterval(() => {
                let param = this.socketParam();
                this.statisticSocket['socket'].send(JSON.stringify(param));
            }, 2000)
        },

        socketError(e) {
            clearInterval(this.statisticSocket['timer']);
            console.warn('WebSocket 错误：', e);
        },

        socketClose(e) {
            clearInterval(this.statisticSocket['timer']);
            console.warn('websocket 连接关闭', e.code);
        },

        /* socket end */

        // websocket 参数生成
        socketParam() {
            this.statTotalParam = [];
            this.currencyList.map((value, index) => {
                this.statTotalParam.push([value, this.currency_obj[value]]);
            });
            // console.log(this.statTotalParam);
            return {
                'currencys': this.statTotalParam,
                'number': 18
            };
        },

        // 事件选择事件
        showTimeSelect(time, currency) {
            if (time == 'm') {// 48小时
                this.currency_obj[currency] = 2880;
            } else if (time == 'h') {// 1 小时
                this.currency_obj[currency] = 60;
            } else if (time == 'd') {// 1 天
                this.currency_obj[currency] = 1440;
            }
        },

        // 获取订单统计所有数据
        getStatisticTotalData(param) {
            return new Promise((resolve, reject) => {
                var url = this.$url_LN + '/web/get/order/newest';
                get(url, param).then(resp => {
                    if (resp.code == 200) {
                        this.statisticTotalData = resp.data;
                        this.turnShow = true;
                        resolve(resp.data)
                    } else {
                        this.$notify.error({
                            message: resp.info,
                            title: '提示',
                            duration: 1000,
                            offset: 100
                        })
                    }
                })
            })
        },

        // 时间选择高亮
        timeActive(time, currency) {
            var selectTime = this.currency_obj[currency];
            if (selectTime == 2880 && time == 'm') return '#db5634';
            else if (selectTime == 60 && time == 'h') return '#db5634';
            else if (selectTime == 1440 && time == 'd') return '#db5634';
            else if (time == this.totalSelect) return '#db5634';
        },

        // 翻页
        toPage(flag) {
            var stat_list_len = this.statisticTotalData.length;
            var param = {
                'number': this.orderNum,
            };
            
            if (flag == 'go') {// 前一页
                if (this.pages > 1) {// 如果页数大于1
                    this.turnShow = false;
                    var order_id = this.statisticTotalData[0]['order_id'];
                    param['orderId'] = '-'+order_id;
                    this.pages --;
                    this.getStatisticTotalData(param)
                } 
            } else {// 下一页
                if (stat_list_len == this.orderNum) {
                    this.turnShow = false;
                    // 可以翻页
                    var order_id = this.statisticTotalData[stat_list_len - 1]['order_id'];
                    param['orderId'] = order_id;
                    this.pages ++;
                    this.getStatisticTotalData(param).then(data => {
                        var stat_len = data.length;
                        if (stat_len == 0) {// 此时已经没有数据了, 跳转到第一页
                            delete param['orderId'];
                            this.getStatisticTotalData(param);
                            this.pages = 1;
                        } 
                    })
                }
            }
        },

        // 交易类型颜色判断
        typesJudge(type) {
            if (type == '卖出' || type == '平多' || type == '开空') return '#1AB394';
            return '#DA5634';
        },

        // 根据任务id，判断任务名字
        taskIdJudge(taskId) {
            for (var i=0; i<this.taskList.length; i++) {
                if (this.taskList[i].id == taskId) {
                    return this.taskList[i].name;
                }
            }
            return taskId;
        },

        // client_id 切割
        clientIdCut(data) {
            if (data !== '手动') {
                var data = String(data)
                var data_len = data.length;
                var new_client_id = data.substr(data_len-4, data_len);
                return '...'+new_client_id;
            } else {
                return String(data);   
            }
        },

        shrinkEvent() {
            this.currencyFlag = !this.currencyFlag;
        },  
        
        // 获取总的统计数据 新
        getTotalData(time) {
            var url = this.$url_LN + '/web/get/order/totalData';
            this.totalSelect = time;
            get(url, {'number': time}).then(resp => {
                if (resp.code == 200) {
                    this.statisticData = resp.data;
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: "提示",
                        offset: 100,
                        duration: 1000
                    })
                }
            })
        },

        // 跳转到指定页面事件
        jumpPage() {
            let result = this.pageNum.replace(/[^\d]/g, "");
            if (result) {
                this.turnShow = false;
                this.getPageStatData(this.pageNum);
            } else {
                this.$notify.error({
                    message: "请输入数字",
                    title: "提示",
                    offset: 100,
                    duration: 1000
                })
            }
        },

        // 获取指定页数的统计数据
        getPageStatData(pageNum) {
            let url = this.$url_LN + "/web/get/order/paging";
            let param = {
                "eachPageNumber": this.orderNum,
                "pagingNumber": pageNum
            };

            get(url, param).then(resp => {
                if (resp.code == 200) {
                    if (String(pageNum) == '1') {
                        this.totalPages = resp.data.total_paging;
                        this.pages = Number(pageNum);
                    } else {
                        this.pages = Number(pageNum);
                        this.statisticTotalData = resp.data.data;
                        this.totalPages = resp.data.total_paging;
                    }
                    this.turnShow = true;
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: "提示",
                        offset: 100,
                        duration: 1000
                    })
                    this.turnShow = true;
                }
            })
        },
    }
}
</script>

<style lang="scss">
    .statistic{
        .loading-content{
            position: absolute;
            left: 50%;
            top: 40%;
            .loading-box{
                color: #a8a7a9;
                span{
                    font-size: 40px;
                }
            }
        }
        .el-main{
            background-color: #252425;
            .statistic-title{
                display: flex;
                justify-content: space-between;
                background-color: #1e1e1e;
                h3{
                    text-align: left;
                    color: #a8a7a9;
                }
                span{
                    color: #828182;
                }
                span:hover{
                    cursor: pointer;
                }
            }
            .statistic-content{
                color: #a8a7a9;
                // margin-top: 10px;
                background-color: #2A2D2E;
                .statistic-table{
                    width: 100%;
                    background-color: #2A2D2E;
                    thead{
                        background-color: #262829;
                        tr{
                            th{
                                padding: 5px 10px;
                            }
                        }
                    }
                }
                .statistic-content-total{
                    display: flex;
                    flex-wrap: wrap;
                    padding: 5px;
                    h3{
                        text-align: center;
                        padding-top: 5px;
                        span{
                            font-size: 12px;
                        }
                    }
                    .total-item{
                        text-align: left;
                        padding: 0 10px;
                        box-shadow: 0 0 10px #000;
                        min-width: 140px;
                        margin-bottom: 5px;
                        padding-bottom: 10px;
                        flex-grow: 1;
                        p{
                            font-size: 12px;
                            text-align: center;
                        }
                        h3{
                            text-align: center;
                        }
                        div{
                            font-size: 12px;
                            span{
                                text-align: center;
                            }
                        }
                        .total-item-title{
                            display: flex;
                            justify-content: space-between;
                            padding: 8px 0;
                            padding-bottom: 10px;
                            div{
                                padding-top: 5px;
                                span{
                                    margin-left: 4px;
                                    font-size: 12px;
                                }
                                span:hover{
                                    cursor: pointer;
                                    color: #fff;
                                }
                            }
                            span{
                                // padding: 6px 0;
                                margin-left: 10px;
                            }
                            h3{
                                color: #db5634;
                            }
                        }
                        .total-item-value{
                            display: flex;
                            justify-content: space-around;
                            padding-bottom: 5px;
                            span{
                                font-size: 14px;
                            }
                        }
                        table{
                            border-collapse: collapse;
                            width: 100%;
                            thead{
                                tr{
                                    th{
                                        border-top: 1px solid #565556;
                                        text-align: center;
                                    }
                                }
                            }
                            tbody{
                                tr{
                                    td{
                                        font-size: 12px;
                                        padding: 3px 5px;
                                        text-align: left;
                                    }
                                    .border-right{
                                        text-align: right;
                                    }
                                }
                                .manual{
                                    td{
                                        color: #636363;
                                    }
                                }
                            }
                        }
                    }
                }
                .total-detail{
                    padding: 10px;
                    .total-detail-header{
                        background-color: #1e1e1e;
                    }
                    .total-detail-table{
                        width: 100%;
                        border-collapse: collapse;
                        thead{
                            background-color: #1e1e1e;
                            tr{
                                th{
                                    padding: 10px 5px;
                                    text-align: right;
                                }
                            }
                        }
                        tbody{
                            background-color: #262829;
                            tr{
                                td{
                                    padding: 4px 5px;
                                    font-size: 12px;
                                    text-align: right;
                                    color: #828182;
                                    .el-button{
                                        // background-color: #262829;
                                        border-color: transparent;
                                        background-color: transparent;
                                        padding: 0;
                                    }
                                }
                            }
                            tr:nth-child(even) {
                                background-color: #262829;
                            }
                            tr:hover{
                                background-color: #1e1e1e;
                                color: #fff;
                            }
                        }
                    }

                    .total-footer{
                        // position: fixed;
                        // bottom: 40px;
                        // left: 50%;
                        // transform: translateX(-50%);
                        span{
                            padding: 0 3px;
                        }
                        .left-page:hover{
                            cursor: pointer;
                            color: #fff;
                        }
                        .right-page:hover{
                            cursor: pointer;
                            color: #fff;
                        }
                        .jump-turn-page{
                            width: 20px;
                            margin-right: 5px;
                            outline: none;
                            border: 1px solid #262829;
                            opacity: 0.3;
                            color: #000;
                            padding: 2px;
                        }
                        .jump-page-btn{
                            outline: none;
                            border-radius: 2px;
                            border: 1px solid #262829;
                            font-size: 12px;
                            padding: 0 5px;
                            text-align: center;
                        }
                        .jump-page-btn:hover{
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1200px) {
        .statistic{
            .el-main{
                .statistic-content{
                    .statistic-query{
                        display: none;
                    }
                    .statistic-content-total{
                        .total-item{
                            table{
                                tbody{
                                    tr{
                                        td{
                                            padding: 3px 5px !important;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width: 800px){
        .statistic{
            .el-main{
                .statistic-content{
                    .statistic-query{
                        display: none;
                    }
                    .statistic-content-total{
                        .total-item{
                            table{
                                tbody{
                                    tr{
                                        td{
                                            padding: 3px 5px;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    @media screen and (max-width: 420px) {
        .statistic{
            .el-main{
                .statistic-content{
                    .total-detail{
                        padding: 0;
                        width: 100%;
                        overflow-x: scroll;
                        .total-detail-table {
                            thead {
                                tr {
                                    th {
                                        min-width: 70px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
